module.exports = __webpack_public_path__ + "img/222929.1ead3a46.png";